module.exports = __webpack_public_path__ + "img/pockets_place.ff9194b3.png";